import { Environment } from '@src/config/environment';
import { SearchParamKeys } from '@funnellab/shared/src/types/SearchParamKeys.ts';

export const shouldRedirectToLogin = (url: Pick<URL, 'pathname'>) => {
  return !(
    url.pathname.includes('/register') ||
    url.pathname.includes('/login') ||
    url.pathname === '/'
  );
};

export const appendLoginRedirectUrlParam = (
  path: string,
  requestUrl: string,
) => {
  const searchParams = new URLSearchParams();
  searchParams.append(
    SearchParamKeys.LOGIN_REDIRECT_URL,
    requestUrl.replace(Environment.APP_URL, ''),
  );

  return `${path}?${searchParams.toString()}`;
};
